<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.btnColor"
        icon small outline>
        <v-icon>
          {{iconBtn}}
        </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogExtraLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            {{title}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-timeline class="ml-4 mr-4">
            <v-timeline-item
              v-for="i in this.list.length"
              :key="i"
              :color="ui.btnColor"
              :icon="list[i-1].icon"
              large
          >
          <template v-slot:opposite>
          </template>
            <v-card :class="ui.cardElev1">
              <v-card-title :class="ui.textSubheadingBold">
                {{list[i-1].title}}
              </v-card-title>
              <v-card-text>
                <v-layout row :class="ui.textSubheading">
                  {{list[i-1].uname}}
                </v-layout>
                <v-layout row :class="ui.textDescriptionBold">
                  {{dateTypeB(list[i-1].date)}}
                </v-layout>
                <v-layout row :class="ui.textDescription">
                  {{list[i-1].ucom}}
                </v-layout>
              </v-card-text>
            </v-card>
            </v-timeline-item>
          </v-timeline>
          <v-layout row>
            <v-spacer/>
            <v-btn
              @click="closeDialog()"
              :color="ui.btnColor"
              flat
            >
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getTransitions"]),
    trans() {
      return this.getTransitions;
    },
    list() {
      let list = null;
      if (this.data.type === "history") {
        list = this.trans.hist;
      } else {
        list = this.trans.flow;
      }
      return list;
    },
    title() {
      let title = null;
      if (this.data.type === "history") {
        title = "Approval Process History";
      } else {
        title = "Transitions Flow";
      }
      return title;
    },
    iconBtn() {
      let icon = null;
      if (this.data.type === "history") {
        icon = "history_toggle_off";
      } else {
        icon = "filter_list";
      }
      return icon;
    }
  },
  mixins: [dateFunctions, apptheme, transFunctions],
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
